// ════════════════════════════════════════════════════════════════
//  STAGING ENVIRONMENT
//  Build:  ng build --configuration=staging
//  Deploy: Cloudflare Pages (staging-admin.heyjivu.com)
//
//  TODO: Fill in values marked ← FILL THIS before deploying
// ════════════════════════════════════════════════════════════════
export const environment = {
  production: false,
  envName: 'staging',

  // ── API ────────────────────────────────────────────────────────
  // ← FILL THIS: your staging Azure Function / App Service URL
  apiUrl: 'https://staging-admin-api.heyjivu.com/api',
  authApiUrl: 'https://staging-api.heyjivu.com/api',

  // ── Storage — R2 direct playback ──────────────────────────────
  // ← FILL THIS (optional): your staging R2 public domain
  // If empty, presigned URLs from API are used (more secure)
  r2PublicDomain: '',
  useDirectVideoUrls: true,
  presignedUrlExpiryMinutes: 60,

  // ── Auth ───────────────────────────────────────────────────────
  // Add staging.hyejivu.com to Google OAuth authorized redirect URIs
  googleClientId: '579233474156-9dpbpojf1k3nop0884sniru752e6s4q6.apps.googleusercontent.com',

  // ── Encryption ─────────────────────────────────────────────────
  // ← FILL THIS: must match EncryptionKey in appsettings.Staging.json (exactly 32 chars)

  // ── Feature Flags ─────────────────────────────────────────────
  enableMockData: false,
  enableDevtools: true,
  showEnvironmentBadge: true,   // shows "STAGING" badge in the UI corner
};
